if (window.module) module = window.module
